<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="bankrekvs"
      sort-by="calories"
      :search="search"
      dense
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <!-- <v-toolbar-title>Банковские реквизиты</v-toolbar-title> -->
          <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
          <!-- <v-spacer></v-spacer> -->
          <v-dialog v-model="dialog" max-width="500px">
            <template
              v-slot:activator="{ on }"
              v-if="checkRole(roleObj.finexpertAdmin)"
            >
              <v-btn color="success" dark class="mb-2" v-on="on"
                >Добавить</v-btn
              >
            </template>
            <v-card>
              <v-toolbar>
                <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text>
                <v-form ref="form" v-model="valid">
                  <v-text-field
                    v-model="editedItem.bik"
                    label="БИК"
                    v-mask="'#########'"
                    :rules="rules.bik"
                  ></v-text-field>
                  <v-text-field
                    v-model="editedItem.account"
                    label="Расчетный счет"
                    v-mask="'####################'"
                    :rules="rules.bankAccount"
                  ></v-text-field>
                  <v-text-field
                    v-model="editedItem.bank"
                    label="Название банка"
                    :rules="rules.nameRules"
                  ></v-text-field>
                  <v-text-field
                    v-model="editedItem.corrAccount"
                    label="Кор. счет"
                    v-mask="'####################'"
                    :rules="rules.bankAccount"
                  ></v-text-field>
                  <v-switch
                    v-model="editedItem.av"
                    label="Использовать для перечисления агентского вознаграждения"
                  ></v-switch>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey" @click="close">Закрыть</v-btn>
                <template v-if="editedIndex > -1">
                  <v-btn @click="deleteItem(editedItem.id)" dark color="red"
                    >Удалить</v-btn
                  >
                </template>
                <v-btn dark color="success" @click="save">Сохранить</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.av="{ item }">
        {{ item.av == 1 ? "Да" : "Нет" }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon color="primary" small class="mr-2" @click="editItem(item)">
          edit
        </v-icon>
        <v-icon small @click="deleteItem(item.id)"> delete </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Globalrules from "@/components/api/rules.js";
import Swal from "sweetalert2";
import { roleObj } from '@/plugins/roles.js';
export default {
  components: {},
  data() {
    return {
      roleObj,
      rules: Globalrules,
      search: "",
      activeBtn: 2,
      showNav: true,
      valid: true,
      dialog: false,
      bankrekvs: [],
      editedIndex: -1,
      editedItem: {
        bik: "",
        account: "",
        bank: "",
        corrAccount: "",
        cartotec: false,
        av: false,
      },
      defaultItem: {
        bik: "",
        account: "",
        bank: "",
        corrAccount: "",
        cartotec: false,
        av: false,
      },
    };
  },

  filters: {
    toBool(val) {
      if (val) return "Да";
      else return "Нет";
    },
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Новая запись" : "Редактировать запись";
    },
    headers() {
      const adminHeader = [
        {
          text: "БИК",
          align: "left",
          sortable: false,
          value: "bik",
        },
        { text: "Расчетный счет", value: "account" },
        { text: "Название банка", value: "bank" },
        { text: "Кор. счет", value: "corrAccount" },
        { text: "Для перечисления АВ", value: "av" },
        { text: "Действия", value: "action", sortable: false },
      ];
      const managerHeader = [
        {
          text: "БИК",
          align: "left",
          sortable: false,
          value: "bik",
        },
        { text: "Расчетный счет", value: "account" },
        { text: "Название банка", value: "bank" },
        { text: "Кор. счет", value: "corrAccount" },
        { text: "Для перечисления АВ", value: "av" },
      ];
      return this.checkRole(roleObj.fiexpertAdmin) ? adminHeader : managerHeader;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    comeTo(name) {
      this.$router.push("/" + name);
    },
    initialize() {
      this.$store.dispatch("getAgentFirmBankRekv").then(() => {
        this.bankrekvs = this.$store.getters.getAgentFirmBankRekv;
      });
    },

    editItem(item) {
      this.editedIndex = this.bankrekvs.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(id) {
      this.$store.dispatch("deleteAgentFirmBankRekv", id).then(() => {
        this.bankrekvs = this.$store.getters.getAgentFirmBankRekv;
        Swal.fire({
          icon: "success",
          title: "Удалено",
          text: "Удаление прошло успешно",
        });
      });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.form.resetValidation();
      }, 300);
    },
    delete() {},

    save() {
      var data;

      if (!this.$refs.form.validate()) {
        Swal.fire({
          icon: "error",
          title: "Не все поля заполнены правильно",
          text: "Проверьте правильность заполнения обязательных полей",
        });
        return;
      }

      if (this.editedIndex > -1) {
        //Object.assign(this.bankrekvs[this.editedIndex], this.editedItem);
        data = {
          id: this.editedItem.id,
          agent_firms_id: this.editedItem.agent_firms_id,
          bik: this.editedItem.bik,
          account: this.editedItem.account,
          bank: this.editedItem.bank,
          corrAccount: this.editedItem.corrAccount,
          cartotec: this.editedItem.cartotec,
          av: this.editedItem.av,
        };
        this.$store.dispatch("updateAgentFirmBankRekv", data).then(() => {
          this.bankrekvs = this.$store.getters.getAgentFirmBankRekv;
        });
      } else {
        data = {
          bik: this.editedItem.bik,
          account: this.editedItem.account,
          bank: this.editedItem.bank,
          corrAccount: this.editedItem.corrAccount,
          cartotec: this.editedItem.cartotec,
          av: this.editedItem.av,
        };
        this.$store.dispatch("storeAgentFirmBankRekv", data).then(() => {
          this.bankrekvs = this.$store.getters.getAgentFirmBankRekv;
        });
      }
      this.close();
    },
  },

  mounted() {
    this.setTitle(`Банковские реквизиты`);
  },
  created() {
    this.initialize();
  },
};
</script>

<style lang="scss"></style>
